import React, { createContext, useContext, useState, useEffect } from 'react';
import { EntityMap, getCache } from '../utils/getCache';
import { toast } from "react-toastify";

type EntityContextProps = {
    entityMap: EntityMap;
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

const EntityContext = createContext<EntityContextProps | undefined>(undefined);

export const EntityProvider: React.FC<{children: React.ReactNode }> = ({ children }) => {
    const [entityMap, setEntityMap] = useState<EntityMap>({});
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [hasShownError, setHasShownError] = useState(false);

    //sorting entity list values
    const compareByName = (a:any, b: any) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      };

   
      
      
    const fetchEntityMap = async () => {
        setLoading(true);
        setError(null);

        try{
            const data = await getCache();
            for (const arr of Object.values(data)) {
                arr.sort(compareByName);
              }

            // console.log("sorted list of cache values is", data)
            setEntityMap(data);
            setError(null);
        } catch (err) {
            setEntityMap({});
            setError("Error loading dropdown values.Try refreshing.");
            if(!hasShownError) {
                toast.error("Error loading dropdown values.Try refreshing.");
                setHasShownError(true);
            }
        } finally {
            setLoading(false);
        }
    };
    

    useEffect(() => {
        fetchEntityMap();
    }, []);

    return (
        <EntityContext.Provider 
            value ={{
                entityMap,
                loading,
                error,
                refetch: fetchEntityMap,
            }}
            >
                {children}
                </EntityContext.Provider>
    );
};
export const useEntityContext = (): EntityContextProps => {
    const context = useContext(EntityContext);
    if(!context) throw new Error("useEntityContext must be used within EntityProvider");
    return context;
};

